// Aynı sekmedeki localStorage yazımlarını duyurmak için (F19). Tarayıcının
// `storage` olayı yalnızca DİĞER sekmelerde ateşlenir; `useClientValue`
// abonelikleri bu olayı da dinler. "use client" damgası taşımaz ki
// `lib/theme.ts` (kök layout'un sunucu tarafından da okunur) buradan import
// edebilsin.
export const LOCAL_STORAGE_EVENT = "pp:storage";

export function announceStorage(): void {
  if (typeof window === "undefined") return;
  window.dispatchEvent(new Event(LOCAL_STORAGE_EVENT));
}
